
export const ACTION_CANCEL_MOD = "Отменить проверку"
